<template>
  <div>
    <div class="divider" />
    <div class="billing-wrapper">
      <div>
        <div class="title">Billing Amount</div>
        <div class="amount" v-if="!isPublic">
          {{ amountEarned | currencyFilter("$", 2) }}
          <span class="amount"
            >({{ amountEarnedToClient | currencyFilter("$", 2) }})</span
          >
        </div>
        <div class="amount" v-if="isPublic">
          {{ amountEarnedToClient | currencyFilter("$", 2) }}
        </div>
      </div>
      <div>
        <div class="title">Hours Total</div>
        <div class="hours">{{ monthHours }}</div>
      </div>
    </div>
    <div class="divider" />
    <Calendar
      style="width: 100%"
      :index="'techDashboard'"
      :data="calendarData"
      :key="calendarKey"
      v-on:dateChange="updateCalendarBoard"
    ></Calendar>
  </div>
</template>

<script>
import Calendar from "@/components/public/Calendar.vue";
import { db } from "@/vendor/firebase";
import * as utils from "@/utils/utils";
import moment from "moment";

export default {
  props: [
    "email",
    "projectId",
    "rate",
    "rateType",
    "rateToClient",
    "rateTypeToClient",
    "isPublic",
  ],
  components: {
    Calendar,
  },
  data() {
    return {
      calendarData: {},
      calendarKey: 0,
      jobs: null,
      monthHours: 0,
      amountEarned: 0,
      amountEarnedToClient: 0,
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    jobs: function () {
      this.updateWorkLogAndCalendar();
    },
  },
  methods: {
    initData() {
      this.$bind(
        "jobs",
        db.collection("jobs").where("consultant", "==", this.email)
      );
    },
    updateCalendarBoard: function (ts) {
      if (this.jobs) {
        const startTimestamp = ts / 1000;
        const endTimestamp =
          moment(ts).tz("America/Los_Angeles").endOf("month").valueOf() / 1000;
        this.nextPayrollDate = moment(ts)
          .tz("America/Los_Angeles")
          .endOf("month")
          .format("MM/DD/YYYY");
        let monthHours = 0;
        let amountEarned = 0;
        let amountEarnedToClient = 0;
        this.jobs.forEach((item) => {
          if (
            item.check_in >= startTimestamp &&
            item.check_in <= endTimestamp &&
            item.project_id === this.projectId
          ) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            monthHours += hours;
            const amount = hours * utils.toNumber(this.rate || 0);
            amountEarned += amount;
            const amountToClient =
              hours * utils.toNumber(this.rateToClient || 0);
            amountEarnedToClient += amountToClient;
          }
        });
        this.monthHours = monthHours;
        this.amountEarned =
          this.rateType === "monthly" ? this.rate : amountEarned;
        this.amountEarnedToClient =
          this.rateTypeToClient === "monthly"
            ? this.rateToClient
            : amountEarnedToClient;
      }
    },
    updateWorkLogAndCalendar: function () {
      if (this.jobs) {
        const calendarData = {};
        this.jobs.forEach((item) => {
          if (item.project_id === this.projectId) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            const calendarIndex = utils.dateformat(item.check_in, "YYYYMMDD");
            if (calendarData["i_" + calendarIndex]) {
              calendarData["i_" + calendarIndex] = {
                hours: calendarData["i_" + calendarIndex].hours + hours,
                isHistory: true,
              };
            } else {
              calendarData["i_" + calendarIndex] = {
                hours: hours,
                isHistory: true,
              };
            }
          }
        });
        this.calendarData = calendarData;
        this.calendarKey++;
        this.updateCalendarBoard(
          moment().tz("America/Los_Angeles").startOf("month").valueOf()
        );
      }
    },
  },
};
</script>

<style scoped>
.divider {
  height: 1px;
  background: #e8e8e8;
  margin: 16px 0;
}
.billing-wrapper {
  display: flex;
}
.billing-wrapper > :not(:first-child) {
  margin-left: 60px;
}
.title {
  font-size: 16px;
  line-height: 24px;
  color: #585757;
  margin-bottom: 8px;
}
.amount {
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #1c1c1c;
}
.hours {
  font-size: 20px;
  line-height: 28px;
  color: #969696;
}
</style>
